<div class="synchronization-module">
  <div class="panel">
    <div class="row">
      <h1>{{'PROJECTSMANAGEMENT.Title' | translate}}</h1>
    </div>
    <div class="row">
      <div class="form-group col-sm-4">
        <label *ngIf="instanceList?.length > 1" for="projectList">{{'SYNCHRONIZATION.Instance' | translate}}:</label>
        <p-select *ngIf="instanceList?.length > 1" name="instanceList" [options]="instanceList" optionLabel="Name"
          [style]="{'width':'100%'}" [(ngModel)]="currentInstance" (ngModelChange)="resetTable()"
          scrollHeight="300px"></p-select>
      </div>
      <div class="form-group col-sm-4">
        <label>{{'PROJECTSMANAGEMENT.ShowDeleted'|translate}}</label>
        <br/>
        <p-toggleswitch (onChange)="handleChange($event)"  [(ngModel)]="showDeleted" ></p-toggleswitch>
      </div>      
    </div><br>
          <div class="row">
            <div class="col-sm-2 date-input">
              <label>{{'PROJECTINFO.From' | translate}}: </label>
              <p-datepicker [(ngModel)]="startDate" [style]="{'width':'100%'}" [keepInvalid]="true"
                [inputStyle]="{'width':'100%'}" (onSelect)="filterDate($event, 'StartDate', 'gte')"
                [readonlyInput]="true">
              </p-datepicker>
            </div>
            <div class="col-sm-2 date-input">
              <label>{{'PROJECTINFO.To' | translate}}: </label>
              <p-datepicker [(ngModel)]="finishDate" [style]="{'width':'100%'}" [keepInvalid]="true"
                [inputStyle]="{'width':'100%'}" (onSelect)="filterDate($event, 'FinishDate', 'lte')"
                [readonlyInput]="true">
              </p-datepicker>
            </div>
            <div class="col-sm-6 reset">
              <button style="margin-top: 23px;" type="button" class="btn btn-primary" (click)="resetTable()">{{'PROJECTINFO.Reset' | translate}}</button>
            </div>
          </div>
      </div>
      <hr>
      <div class="panel">
        <p-table #dt [value]="projects" showGridlines sortMode="multiple" [paginator]="true" [rows]="15" [globalFilterFields]="['ProjectName','SchedulerName','Site']">
          <ng-template pTemplate="caption">
            <div class="row">
              <div class="col-sm-6">
                <input type="text" pInputText placeholder="{{'USERS.Filter' | translate}}" (input)="dt.filterGlobal($event.target.value, 'contains')"
                  class="form-control">
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th scope="col" pSortableColumn="InstanceName">
                {{'PROJECTINFO.InstanceName' | translate}}
                <p-sortIcon field="InstanceName" ariaLabel="{{'PROJECTINFO.ActivateSort' | translate}}"
                  ariaLabelDesc="{{'PROJECTINFO.ActivateSortDesc' | translate}}"
                  ariaLabelAsc="{{'PROJECTINFO.ActivateSortAsc' | translate}}">
                </p-sortIcon>
              </th>
              <th scope="col" pSortableColumn="ProjectName">
                {{'PROJECTINFO.ProjectName' | translate}}
                <p-sortIcon field="ProjectName" ariaLabel="{{'PROJECTINFO.ActivateSort' | translate}}"
                  ariaLabelDesc="{{'PROJECTINFO.ActivateSortDesc' | translate}}"
                  ariaLabelAsc="{{'PROJECTINFO.ActivateSortAsc' | translate}}">
                </p-sortIcon>
              </th>
              <th scope="col" pSortableColumn="ProjectType">
                {{'PROJECTINFO.ProjectType' | translate}}
                <p-sortIcon field="ProjectType" ariaLabel="{{'PROJECTINFO.ActivateSort' | translate}}"
                  ariaLabelDesc="{{'PROJECTINFO.ActivateSortDesc' | translate}}"
                  ariaLabelAsc="{{'PROJECTINFO.ActivateSortAsc' | translate}}">
                </p-sortIcon>
              </th>
              <th scope="col" pSortableColumn="StartDate">
                {{'PROJECTINFO.StartDate' | translate}}
                <p-sortIcon field="StartDate" ariaLabel="{{'PROJECTINFO.ActivateSort' | translate}}"
                  ariaLabelDesc="{{'PROJECTINFO.ActivateSortDesc' | translate}}"
                  ariaLabelAsc="{{'PROJECTINFO.ActivateSortAsc' | translate}}">
                </p-sortIcon>
              </th>
              <th scope="col" pSortableColumn="FinishDate">
                {{'PROJECTINFO.FinishDate' | translate}}
                <p-sortIcon field="FinishDate" ariaLabel="{{'PROJECTINFO.ActivateSort' | translate}}"
                  ariaLabelDesc="{{'PROJECTINFO.ActivateSortDesc' | translate}}"
                  ariaLabelAsc="{{'PROJECTINFO.ActivateSortAsc' | translate}}">
                </p-sortIcon>
              </th>
              <th scope="col" pSortableColumn="Completed">
                {{'PROJECTINFO.ProjectCompleted' | translate}}
                <p-sortIcon field="Completed" ariaLabel="{{'PROJECTINFO.ActivateSort' | translate}}"
                  ariaLabelDesc="{{'PROJECTINFO.ActivateSortDesc' | translate}}"
                  ariaLabelAsc="{{'PROJECTINFO.ActivateSortAsc' | translate}}">
                </p-sortIcon>
              </th>
              <th scope="col" pSortableColumn="Enabled">Active
                <p-sortIcon field="Active" ariaLabel="{{'PROJECTINFO.ActivateSort' | translate}}"
                  ariaLabelDesc="{{'PROJECTINFO.ActivateSortDesc' | translate}}"
                  ariaLabelAsc="{{'PROJECTINFO.ActivateSortAsc' | translate}}">
                </p-sortIcon>
              </th>
              <th scope="col" pSortableColumn="Configured">Configured
                <p-sortIcon field="Configured" ariaLabel="{{'PROJECTINFO.ActivateSort' | translate}}"
                  ariaLabelDesc="{{'PROJECTINFO.ActivateSortDesc' | translate}}"
                  ariaLabelAsc="{{'PROJECTINFO.ActivateSortAsc' | translate}}">
                </p-sortIcon>
              </th>
              <th scope="col" pSortableColumn="SchedulerName">Scheduler's Name
                <p-sortIcon field="SchedulerName" ariaLabel="{{'PROJECTINFO.ActivateSort' | translate}}"
                  ariaLabelDesc="{{'PROJECTINFO.ActivateSortDesc' | translate}}"
                  ariaLabelAsc="{{'PROJECTINFO.ActivateSortAsc' | translate}}">
                </p-sortIcon>
              </th>
              <th scope="col" pSortableColumn="Site">Obs Name
                <p-sortIcon field="Site" ariaLabel="{{'PROJECTINFO.ActivateSort' | translate}}"
                  ariaLabelDesc="{{'PROJECTINFO.ActivateSortDesc' | translate}}"
                  ariaLabelAsc="{{'PROJECTINFO.ActivateSortAsc' | translate}}">
                </p-sortIcon>
              </th>
            </tr>
            <tr>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col" [ngSwitch]="'projectType'">
                <p-multiSelect [ngSwitch]="'projectType'" [options]="projectTypefilterOpts"
                  defaultLabel="{{'PROJECTINFO.AllTypes' | translate}}" (onChange)="filterByProjectType($event)">
                </p-multiSelect>
              </th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col" [ngSwitch]="'completed'">
                <p-multiSelect [ngSwitch]="'completed'" [options]="filterCompletedStatusOpts"
                  defaultLabel="{{'PROJECTINFO.AllStatus' | translate}}" (onChange)="filterByProjectState($event)">
                </p-multiSelect>
              </th>
              <th scope="col"></th>
              <th scope="col">
                <p-multiSelect [ngSwitch]="'Configured'" [options]="filterConfiguredStatusOpts"
                defaultLabel="{{'PROJECTINFO.Both' | translate}}" (onChange)="filterByConfigured($event)">
              </p-multiSelect>
              </th>
              <th scope="col"></th>
              <th scope="col"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-info>
            <tr>
              <td>{{info.ProjectInstanceName}} - {{info.ProjectId}}</td>
              <td>{{info.ProjectName}}</td>
              <td>{{info.ProjectType}}</td>
              <td>{{info.StartDate === null ? '---' :(info.StartDate | date:'M/d/yyyy')}}</td>
              <td>{{info.FinishDate === null ? '---' :(info.FinishDate | date:'M/d/yyyy')}}</td>
              <td>{{(info.Completed? 'SHARED.Yes' : 'SHARED.No') | translate}}</td>
              <td>
                  <div>
                    <p-toggleswitch [(ngModel)]="info.Enabled" (click)="selectionChange(info)"></p-toggleswitch>
                  </div>
              </td>
              <td>
                <div>
                {{(info.Configured?'SHARED.Yes' : 'SHARED.No') | translate}}
              </div>
            </td>
            <td>{{info.SchedulerName}}</td>
            <td>{{info.Site}}</td>
            </tr>
          </ng-template>
        </p-table>
        </div>
  </div>